import React from "react";
import { useQuery } from "@tanstack/react-query";
import api, { relTime } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export const ImpersonationLog = () => {
  const { data: logs = [] } = useQuery({ queryKey: ["sa-imp-logs"], queryFn: () => api.get("/superadmin/impersonations").then((r) => r.data) });
  return (
    <Card className="rounded-sm bg-card border-border p-6 mt-6" data-testid="impersonation-log">
      <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-bold">Audit</div>
      <div className="font-display text-xl font-extrabold mb-4">Impersonation log</div>
      {logs.length === 0 ? <div className="text-sm text-muted-foreground">No impersonation sessions yet.</div> : (
        <div className="space-y-1 max-h-72 overflow-y-auto">
          {logs.map((l) => (
            <div key={l.id} className="grid grid-cols-12 gap-2 items-center p-2 rounded-sm bg-secondary/20 text-xs" data-testid="impersonation-log-row">
              <div className="col-span-3 font-semibold truncate">{l.company_name}</div>
              <div className="col-span-3 truncate text-muted-foreground">as {l.target_email}</div>
              <div className="col-span-2 truncate text-muted-foreground">by {l.super_admin_email}</div>
              <div className="col-span-2 text-muted-foreground">{relTime(l.started_at)}</div>
              <div className="col-span-2 text-right">
                {l.ended_at
                  ? <Badge variant="outline" className="rounded-sm text-[10px]">ended {relTime(l.ended_at)}</Badge>
                  : <Badge className="rounded-sm text-[10px] bg-amber-500/15 text-amber-400 border-amber-500/30">active / expired</Badge>}
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};
